import React from "react";

function Contact(props) {
  return (
    <div>
      <section className="contact-main">
        <h2>Contact Us</h2>

        <p>
          If you have any questions, feedback, or concerns, please feel free to
          reach out to us. We value your input and are here to assist you.
        </p>
        <i>
          <p>ritikpal098@gmail.com</p>
        </i>
      </section>
    </div>
  );
}

export default Contact;
